import SitekeyAddHeader from './SitekeyAddHeader'
import SitekeyMainForm from './SitekeyMainForm'

const SitekeyForm = () => {
  return (
    <div>
      <SitekeyAddHeader />
      <SitekeyMainForm />
    </div>
  )
}
export default SitekeyForm
